import { ColorsUkV1V2 as o } from "../index.js";
import { getChangeColorFunc as r } from "../index2.js";
const c = r(o);
export {
  c as changeColorFuncUkV1V2
};
//# sourceMappingURL=index.js.map
